export const isFullStatic = false
export const staticPath = "/xbuy-vsf/packages/theme/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"